exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sort-toolbar.widget {\n    display: flex;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/sort-toolbar/index.css
// module id = 541
// module chunks = 0